/* global window */
import React, { Component, PropTypes } from 'react';
import Autosuggest from 'react-autosuggest';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changePhrase, queryPatients, clearPatients } from '../actions/searchActions';
import addBasePath from '../utils/addBasePath';
import { formatDate } from '../utils/format';


const renderSuggestion = ({ firstName, lastName, dentist = null, birthDate = null, birthNumber = '', phone = '', addressCity = '' }) => (
	<div>
		{dentist !== null ? <span className="text-dentist"> {dentist}</span> : null}
		<span className="text-primary">{firstName} {lastName}</span>
		<span className="text-muted">{phone !== '' ? `, ${phone}` : null}</span>
		<div className="text-address">
			{birthDate !== null ? formatDate(birthDate) : null}
			{birthDate !== null && birthNumber !== '' ? '; ' : null}{birthNumber}
			{birthDate !== null && addressCity !== '' ? ', ' : null}{addressCity}
		</div>
	</div>);

const getSuggestionValue = suggestion => `${suggestion.firstName} ${suggestion.lastName}`;


const patientType = PropTypes.shape({
	id: PropTypes.string.isRequired,
	firstName: PropTypes.string.isRequired,
	lastName: PropTypes.string.isRequired,
	birthDate: PropTypes.string,
	birthNumber: PropTypes.string,
	phone: PropTypes.string,
	addressCity: PropTypes.string,
});

renderSuggestion.propTypes = {
	firstName: PropTypes.string.isRequired,
	lastName: PropTypes.string.isRequired,
	dentist: PropTypes.string,
	birthDate: PropTypes.string,
	birthNumber: PropTypes.string,
	phone: PropTypes.string,
	addressCity: PropTypes.string,
};

renderSuggestion.defaultProps = {
	dentist: null,
	birthDate: null,
	birthNumber: '',
	phone: '',
	addressCity: '',
};


class PatientLinkSearch extends Component {

	static propTypes = {
		clinic: PropTypes.string,
		patients: PropTypes.arrayOf(patientType.isRequired).isRequired,
		searchPhrase: PropTypes.string.isRequired,
		changePhrase: PropTypes.func.isRequired,
		queryPatients: PropTypes.func.isRequired,
		clearPatients: PropTypes.func.isRequired,
	};

	static defaultProps = {
		clinic: null,
	};

	onInputChange = (event, { newValue }) => {
		this.props.changePhrase(newValue);
	};

	onSuggestionsFetchRequested = ({ value }) => {
		this.props.queryPatients(this.props.clinic, value);
	};

	onSuggestionsClearRequested = () => {
		this.props.clearPatients();
	};

	onSuggestionSelected = (event, { suggestion }) => {
		const ecid = this.props.clinic !== null ? `?ecid=${this.props.clinic}` : '';
		window.location = addBasePath(`medical-report/default/${suggestion.id}${ecid}`);
	};

	render() {
		const inputProps = {
			placeholder: 'Hledat pacienta',
			id: 'frm-searchForm-query',
			name: 'query',
			value: this.props.searchPhrase,
			onChange: this.onInputChange,
			className: 'form-control',
			autoComplete: 'off',
		};

		const patients = this.props.patients.slice(0, 5);
		return (
			<div>
				<Autosuggest
					suggestions={patients}
					onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
					onSuggestionsClearRequested={this.onSuggestionsClearRequested}
					onSuggestionSelected={this.onSuggestionSelected}
					getSuggestionValue={getSuggestionValue}
					renderSuggestion={renderSuggestion}
					inputProps={inputProps}
				/>
			</div>
		);
	}

}


const mapStateToProps = ({ patients, searchPhrase, loading }) => ({
	patients,
	searchPhrase,
	loading,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	changePhrase,
	queryPatients,
	clearPatients,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(PatientLinkSearch);



// WEBPACK FOOTER //
// ./js/components/PatientLinkSearch.js